var crDisable = false;
var crSavePickupProperties = true;
for (crItem of crItems) {
  if (crItem.id === Number(pickupProduct)) {
    crDisable = true;
  }
}
if (crDisable === true) {
  if (typeof tt === 'undefined') {
     var tt = setInterval(function(){
        console.log('dis');
        disableCheckoutButton();
      }, 1000);
      setTimeout(function() { clearInterval(tt); }, 7000);  
  }
      
}
function activateCheckoutButton(){
  //console.log('Activate')
  document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton(){    
  //console.log('Disable')
  document.querySelector('[name=checkout]').disabled = true;
}

// disableCheckoutButton();

// window.addEventListener('load', function() {
//   console.log('## All Scripts loaded ##');
//   activateCheckoutButton()
//   //setTimeout(function(){  activateCheckoutButton();}, 1000)

// })


var debugData = '';
navigator.sayswho= (function(){
    var ua= navigator.userAgent, tem, 
    M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE '+(tem[1] || '');
    }
    if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    return M.join(' ');
})();



document.addEventListener('crPickupActivated', function (e) { 
    if (typeof jQuery != 'undefined') {  
        // jQuery is loaded => print the version
        debugData += "Jquery ver: " + jqCR.fn.jquery;
    }
    debugData += "; Date: " + new Date() + "; Browser: " + navigator.sayswho + "; Pickup container visible: " + $('#pickup-container').is(':visible');

    $('#js-debug-browser').val(debugData)   
  
	jqCR('body').on('click', '[name="checkout"]', function(e){
        var cartForm = jqCR('.cart');
        var action = cartForm.attr('action').replace('/cart?', '/checkout?');
        cartForm.attr('action', action)  

		e.preventDefault();
        var allOk = true;
      
        jqCR.getJSON('/cart', function(response){
          var items = response.items;
          var attributes = response.attributes;
          
          for (var i = 0; i < items.length; i++) {
            var productTitle = items[i].title;
         
            if (productTitle === "Pickup Instore") {              
              if (!attributes.Pickup_date) {
                allOk = false;
                location.reload();
                return false;
              } 
            } 
          }
          
		  if (cartForm.valid() && allOk === true) cartForm.submit()      	                          
        })

    })
    
    
    ////////
    console.log('____ activated _____');



    jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
      //console.log('check for others and activate checkout')  	
      checkPickupFields()
    })

    //jqCR(document).on('change', '#pickup-selected-store', function(){checkPickupFields()})  
    //trackChange(jqCR("#pickup-selected-store")[0] );  

    jqCR(document).on('change', '#note-pickup-date', function(){checkPickupFields()})  
    trackChange(jqCR("#note-pickup-date")[0] );
});

MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

function checkPickupFields(){
  	var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    var selectedStoreId = jqCR('#pickup-selected-store-id').val()
    if (selectedStoreId && firstName && lastName && phone) {
    	activateCheckoutButton();
    } else {
    	disableCheckoutButton()
    }
}